import axios from 'axios';
import { builderAuthHeader } from '../../common/utils/auth';
import {
  HOME_LOAD_PENDING_INVITE_BEGIN,
  HOME_LOAD_PENDING_INVITE_SUCCESS,
  HOME_LOAD_PENDING_INVITE_FAILURE,
  HOME_LOAD_PENDING_INVITE_DISMISS_ERROR,
} from './constants';

export function loadPendingInvite(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_LOAD_PENDING_INVITE_BEGIN,
    });
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}team-member/pending-request`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_LOAD_PENDING_INVITE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_LOAD_PENDING_INVITE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPendingInviteError() {
  return {
    type: HOME_LOAD_PENDING_INVITE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_LOAD_PENDING_INVITE_BEGIN:
      return {
        ...state,
        loadPendingInvitePending: true,
        loadPendingInviteError: null,
      };

    case HOME_LOAD_PENDING_INVITE_SUCCESS:
      return {
        ...state,
        loadPendingInvitePending: false,
        loadPendingInviteError: null,
        pendingInvites: action.data,
      };

    case HOME_LOAD_PENDING_INVITE_FAILURE:
      return {
        ...state,
        loadPendingInvitePending: false,
        loadPendingInviteError: action.data.error,
      };

    case HOME_LOAD_PENDING_INVITE_DISMISS_ERROR:
      return {
        ...state,
        loadPendingInviteError: null,
      };

    default:
      return state;
  }
}
